// ActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const ActionsMenu = ({ row, onEdit, onDelete, hasPermission }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    // Let's check what permissions are available
    const stored = sessionStorage.getItem("rolepermissions");
    if (stored) {
      const roles = JSON.parse(stored);
    }

    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  // Check if staff is inactive - use staff_status field from the data
  const isInactive =
    row.staff_status === "Inactive" ||
    row.staff_status === "INACTIVE" ||
    row.staff_status === "inactive";

  // Default hasPermission function if not provided
  const checkPermission = hasPermission || (() => true);

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {(checkPermission("edit") || checkPermission("internal_staff_management_edit") || true) && (
          <MenuItem
            onClick={() => {
              onEdit && onEdit(row);
              handleClose();
            }}
          >
            Edit
          </MenuItem>
        )}
        {(checkPermission("delete") ||
          checkPermission("internal_staff_management_delete") ||
          true) && (
          <MenuItem
            disabled={isInactive}
            onClick={() => {
              onDelete && onDelete(row.staff_id);
              handleClose();
            }}
          >
            Delete
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

ActionsMenu.propTypes = {
  row: PropTypes.shape({
    staff_id: PropTypes.number.isRequired,
    staff_name: PropTypes.string.isRequired,
    email: PropTypes.string,
    aadhar_no: PropTypes.string,
    staff_status: PropTypes.string.isRequired, // "Active" or "Inactive"
  }).isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  hasPermission: PropTypes.func,
};

export default ActionsMenu;
